import { useState } from 'react';
import { DropdownMenu } from './ui/DropDown/DropdownMenu';
import { DropdownMenuTrigger } from './ui/DropDown/DropdownMenuTrigger';
import { DropdownMenuContent } from './ui/DropDown/DropdownMenuContent';
import ToggleMenuBox from './ui/ToggleMenuBox';
import NavigationApps from './ui/NavigationApps';
import { Button } from './ui/Button';
import { useSubMenu } from './SubMenuContext';
import { Menu } from 'lucide-react';
import { useChat } from './context/ChatContext';
import Boss from './ui/appsIcons/Boss';
import { twMerge } from 'tailwind-merge';
import { useUser } from './UserContext';
import { AppNotificationsDrawer } from './notifications/AppNotificationsDrawer';

interface TopBarProps {
    toggleSidebar?: (toggle?: boolean) => void;
    app: string;
}

const TopBar = ({ app }: TopBarProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const { hideApps } = useUser();

    const { setSideBarOpen, isSidebarOpen } = useSubMenu();

    const { toggleChat, isChatOpen } = useChat();

    const handleOnOpen = (state: boolean) => {
        setIsOpen(state);
    };

    return (
        <div className='w-full h-[45px] empreender-lib-topbar flex flex-row items-center bg-white mb-2 rounded-bl-xl '>
            <div className='flex-1 min-w-0 h-full flex items-center !px-4 gap-x-1 cursor-pointer !pl-[5px]'>
                <Button variant={'ghost'} size={'icon'} onClick={() => setSideBarOpen(!isSidebarOpen)} className='[&>svg]:size-4'>
                    <Menu size={16} />
                </Button>
                <div>
                    {!hideApps ? (
                        <DropdownMenu isOpen={isOpen} setIsOpen={handleOnOpen}>
                            <DropdownMenuTrigger>
                                <ToggleMenuBox app={app} isOpen={isOpen} />
                            </DropdownMenuTrigger>

                            <DropdownMenuContent className='!p-0 shadow-[0px_4px_20px_-6px_rgba(0,_0,_0,_0.12)] border-none rounded-lg'>
                                <NavigationApps />
                            </DropdownMenuContent>
                        </DropdownMenu>
                    ) : (
                        <ToggleMenuBox app={app} isOpen={isOpen} />
                    )}
                </div>
            </div>
            <div className='ml-auto flex items-center gap-1 mr-2 shrink-0'>
                <AppNotificationsDrawer />
                <Button variant={'secondary'} className={twMerge(`${isChatOpen ? 'text-white bg-gray-900' : 'text-gray-900 bg-white'}`)} onClick={() => toggleChat(!isChatOpen)}>
                    <Boss />
                    <span className='text-xs font-medium'>Ajuda</span>
                </Button>
            </div>
        </div>
    );
};

export default TopBar;
